<script setup lang="ts">
import { useI18n } from 'vue-i18n';

import type { LocaleSchema } from '@/locales/index.ts';

const { t } = useI18n<{ message: LocaleSchema }>({
  useScope: 'global'
});

defineOptions({
  name: 'TableColumn'
});

const props = defineProps<{
  field?: string;
  label: string;
  //eslint-disable-next-line @typescript-eslint/no-explicit-any
  item?: any;
  mode?: 'header' | 'cell';
}>();

function getCellValue() {
  if (!props.item || !props.field) return undefined;
  return props.item[props.field];
};

function getCellValueForTemplate() {
  if (!props.item || !props.field) return t('common.notAvailableAbbreviated');
  return props.item[props.field] ?? t('common.notAvailableAbbreviated');
};
</script>

<template>
  <template v-if="mode === 'cell'">
    <td class="dataTable-cell">
      <!-- <span class="dataTable-cardLabel"><slot name="labelIcon"></slot>{{ label }}</span> -->
      <slot name="body"
            :item="item"
            :value="getCellValue()">
        <slot :item="item"
              :value="getCellValue()">
          {{ getCellValueForTemplate() }}
        </slot>
      </slot>
    </td>
  </template>
  <template v-else>
    <th class="dataTable-header">
      <slot name="header"
            :item="item"
            :label="label">
        <slot name="defaultHeader"
              :label="label">
          {{ label }}
        </slot>
      </slot>          
    </th>
  </template>
</template>

<style lang="scss">
.dataTable-cardLabel {
  display: none;
  align-items: center;
  gap: 8px;
}
</style>
